import React from "react";
import { DirectoryComponent } from "../directory-shared/DirectoryComponent";
import { DirectoryLink } from "../directory-shared/DirectoryRouter";
import { StreamingArrayLoaderGetItemsRequest } from "hoksource";
import { ItemCategory } from "../models/entities/items/item-category";
import { ItemCategoryService } from "./ItemCategoryService";
import { InfiniteScroll } from "hok-react";



export class Home extends DirectoryComponent<{},{
    searchString?:string,
    includeInactive?:boolean
}>
{



    constructor(props)
    {
        super(props);
        this.state = {

            searchString:"",
        };
    }
    

    takeCount = 30;

    
    getItems = (filter:
        StreamingArrayLoaderGetItemsRequest<ItemCategory>
     )=>{


        
        var service = new ItemCategoryService(this.http);
        return service.getList({
            skip : filter.currentIndex,
            take : this.takeCount,
            searchString: this.state.searchString,
            includeInactive: this.state.includeInactive
        });
    }


    render()
    {

        return <>
            
        <h1>ItemCategories</h1>
        <p>
            <DirectoryLink to={`/ItemCategories/edit`}>Create New</DirectoryLink>
        </p>



        <div className="row">

            <div className="col-md-6">
                search: 
                    
                <input 
                value={this.state.searchString}

                    onChange={e=>{
                        this.setState({searchString:e.target.value})
                    }}/>
            </div>
            
            <div className="col-md-6 text-right">
                <label>

                    
                <input type="checkbox" 
                checked={this.state.includeInactive}
                onChange={e=>{

                    
                    this.setState({includeInactive:e.target.checked})
                }}
                />

                &nbsp;
                show inactive
                </label>
            </div>
        </div>

        
<table className="table">
<thead>
    <tr>
        <th>
            Name
        </th>
        <th>Active</th>
        <th></th>
    </tr>
</thead>
<tbody>


    
<InfiniteScroll
    targetElement={window}
    maxTakeCount={this.takeCount}
    getItems={this.getItems}
    resetDependencyList={[
        this.state.searchString,
        this.state.includeInactive
    ]}
    resetDebounceDelay={400}
    >{infiniteScroll => 
    
    infiniteScroll.loadedItems?.map(e => 
        (
            <tr key={e.id}>
        <td>
            {e.name}
        </td>
        
        <td>
            {e.active+""}
        </td>
        <td>
            
            <DirectoryLink to={`/ItemCategories/edit?id=${e.id}`}>Edit</DirectoryLink>
        </td>
    </tr>
        )
    )
    
    }


    </InfiniteScroll>

</tbody>
</table>

        </>;




    }
}